(() => {
  'use strict';
  let queued = false;
  const update = () => {
    queued = false;
    document.querySelectorAll('.header').forEach(header => {
      // Colours once the page has scrolled past the header; back to plain only at the very top
      if (window.scrollY >= header.offsetHeight) header.classList.add('is-scrolled');
      else if (window.scrollY <= 0) header.classList.remove('is-scrolled');
      header.querySelectorAll('.cart-toggle span').forEach(count => { count.dataset.empty = String(count.textContent.trim() === '0'); });
    });
  };
  window.addEventListener('scroll', () => {
    if (!queued) { queued = true; requestAnimationFrame(update); }
  }, { passive: true });
  window.addEventListener('pageshow', update);
  document.addEventListener('shopify:section:load', update);
  const countObserver = new MutationObserver(update);
  document.querySelectorAll('[data-cart-count]').forEach(count => countObserver.observe(count, { childList: true, characterData: true, subtree: true }));
  update();
  const initialized = new WeakSet();
  function initMenu(root = document) {
    root.querySelectorAll('[data-mobile-menu-panel]').forEach(panel => {
      if (initialized.has(panel)) return;
      initialized.add(panel);
      const button = document.querySelector('[data-menu]');
      const header = button?.closest('.header');
      if (!button || !header) return;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const breakpoint = matchMedia('(max-width:989px)');
      let timer, entranceTimer, closing = false, afterClose, previousRoot, previousBody;
      panel.dataset.state = 'closed';
      const finish = () => {
        clearTimeout(timer);
        if (panel.open) panel.close();
      };
      const close = (after, immediate = false) => {
        if (!panel.open || closing) return;
        closing = true; afterClose = after;
        clearTimeout(entranceTimer); panel.dataset.state = 'closing';
        panel.classList.remove('is-open');
        if (immediate || reduced.matches) finish();
        else timer = setTimeout(finish, 340);
      };
      button.addEventListener('click', () => {
        if (closing) return;
        if (panel.open) { close(); return; }
        closing = false; afterClose = null;
        previousRoot = document.documentElement.style.overflow;
        previousBody = document.body.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        panel.showModal();
        panel.dataset.state = 'opening';
        button.setAttribute('aria-expanded', 'true');
        button.setAttribute('aria-label', 'Close menu');
        requestAnimationFrame(() => requestAnimationFrame(() => {
          if (!panel.open || closing) return;
          panel.classList.add('is-open');
          if (reduced.matches) panel.dataset.state = 'open';
          else entranceTimer = setTimeout(() => { if (panel.open && !closing) panel.dataset.state = 'open'; }, 340);
        }));
        panel.querySelector('[data-menu-close]')?.focus({ preventScroll: true });
      });
      panel.querySelector('[data-menu-close]')?.addEventListener('click', () => close());
      panel.addEventListener('cancel', event => { event.preventDefault(); close(); });
      panel.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const targets = [...panel.querySelectorAll('button:not([disabled]),a[href],summary,select,input:not([type="hidden"]),[tabindex="0"]')].filter(el => el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
        const first = targets[0], last = targets[targets.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      });
      panel.addEventListener('transitionend', event => {
        if (event.target !== panel || event.propertyName !== 'transform') return;
        if (closing) finish();
        else if (panel.open) { clearTimeout(entranceTimer); panel.dataset.state = 'open'; }
      });
      panel.addEventListener('close', () => {
        panel.classList.remove('is-open'); closing = false; clearTimeout(timer); clearTimeout(entranceTimer);
        document.documentElement.style.overflow = previousRoot || '';
        document.body.style.overflow = previousBody || '';
        button.setAttribute('aria-expanded', 'false'); button.setAttribute('aria-label', 'Open menu');
        (breakpoint.matches ? button : header.querySelector('.brand'))?.focus({ preventScroll: true });
        panel.querySelectorAll('details[open]').forEach(details => { details.open = false; });
        const action = afterClose; afterClose = null; panel.dataset.state = 'closed'; action?.();
      });
      panel.addEventListener('click', event => {
        const action = event.target.closest('[data-menu-action]');
        if (action) {
          close(() => { if (action.dataset.menuAction === 'search') header.querySelector('[aria-label="Search"]')?.click(); else location.href = header.querySelector('[aria-label="Cart"]')?.href || '/cart'; });
          return;
        }
        if (event.target.closest('a')) close();
      });
      breakpoint.addEventListener('change', () => { if (!breakpoint.matches && panel.open) close(undefined, true); });
      document.addEventListener('shopify:section:unload', event => { if (event.target.contains(panel) && panel.open) close(undefined, true); });
    });
  }
  initMenu();
  document.addEventListener('shopify:section:load', event => initMenu(event.target));

  // Inline search bar in the header, opened from the search icon
  const setSearch = (header, open) => {
    const form = header?.querySelector('[data-header-search]');
    if (!form) return false;
    form.hidden = !open;
    header.classList.toggle('is-searching', open);
    header.querySelector('[data-header-search-toggle]')?.setAttribute('aria-expanded', String(open));
    if (open) form.querySelector('input')?.focus();
    return true;
  };
  document.addEventListener('click', event => {
    const toggle = event.target.closest('[data-header-search-toggle]');
    if (toggle) {
      const header = toggle.closest('.header');
      if (setSearch(header, !header.classList.contains('is-searching'))) event.preventDefault();
      return;
    }
    // Clicking anywhere outside the bar closes it
    document.querySelectorAll('.header.is-searching').forEach(header => {
      if (!header.querySelector('[data-header-search]').contains(event.target)) setSearch(header, false);
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.header.is-searching').forEach(header => {
      setSearch(header, false);
      header.querySelector('[data-header-search-toggle]')?.focus({ preventScroll: true });
    });
  });
})();

// Bold the menu item for the page being viewed
(() => {
  const here = location.pathname.replace(/\/$/, '') || '/';
  const matches = href => {
    const path = new URL(href, location.origin).pathname.replace(/\/$/, '') || '/';
    if (path === '/') return here === '/';
    if (here === path || here.startsWith(path + '/')) return true;
    // Shop covers every collection and product page
    return path.startsWith('/collections') && /^\/(collections|products)(\/|$)/.test(here);
  };
  document.querySelectorAll('.desktop-nav').forEach(nav => {
    nav.querySelectorAll(':scope > a').forEach(link => {
      if (matches(link.href)) link.setAttribute('aria-current', 'page');
    });
    nav.querySelectorAll(':scope > .nav-dropdown').forEach(dropdown => {
      const child = [...dropdown.querySelectorAll('a')].find(link => matches(link.href));
      if (child) { child.setAttribute('aria-current', 'page'); dropdown.classList.add('is-current'); }
    });
  });
})();